export default `
/* Default dsui-chrome value */
[data-dsui] {
  --dsui-chrome: hsl(253deg 100% 60%);
  outline: 2px dashed var(--dsui-chrome);
}

/* Olive theme-specific */
[data-dsui-theme="Olive"] {
  --dsui-chrome: hsl(218deg 71% 68%);
}

/* Olive-specific components */
/* Olive-specific props */
/* Olive-specific prop values */
[data-dsui-legacy^="Olive-specific"] {
 --dsui-chrome: hsl(340deg 95% 40%);
}

[data-dsui]::before{
  content: attr(data-dsui) '-' attr(data-dsui-theme);
  position: absolute;
  z-index: 1;
  padding: 0.075rem 0.25rem;
  font-size: 12px;
  font-weight: 500;
  background: var(--dsui-chrome);
  color: #fff;
  white-space: nowrap;
}

[data-dsui-legacy]::before {
 content: attr(data-dsui) "-" attr(data-dsui-legacy) ;
 z-index: 2;
}
`
